// extracted by mini-css-extract-plugin
export default {"component":"bONwi1","badge":"cONwi1","avatar":"dONwi1"};